<template>
  <div>
    <v-breadcrumbs
      :items="breadcrumbs"
      class="grey lighten-2 white--text"
    ></v-breadcrumbs>
    <div>
      <div class="pa-4">
        <div class="d-flex justify-space-between align-center mb-4">
          <v-btn
            small
            depressed
            color="fmq_gray"
            dark
            outlined
            to="/tags"
          >
            <v-icon small> mdi-arrow-left </v-icon>Voltar</v-btn
          >
        </div>
        <TagsFormulario @send="criar" />
      </div>
    </div>
    <AlertSuccess
      :dialog="success"
      dialogMessage="Tag criada com sucesso"
      @close="goToTags"
    />
    <AlertError :alertError="error" :messageError="messageError" />
  </div>
</template>

<script>
import { criarTag } from "@/services/tags";
import TagsFormulario from "@/components/tags/TagsFormulario.vue";
export default {
  name: "TagsCriar",
  components: { TagsFormulario },
  data: () => ({
    breadcrumbs: [
      {
        text: "Tags",
        disabled: false,
        to: "/tags",
      },
      {
        text: "Criar Tag",
        disabled: true,
        to: "",
      },
    ],
    error: false,
    success: false,
    loadingBtn: false,
    messageError: null,
  }),
    beforeCreate() {
    if(this.$store.state.user.data.tipo === "Representante") {
      this.$router.push({path: '/'})
    }
  },
  methods: {
    async criar(event) {
      this.error = false;
      this.sucess = false;
      this.loadingBtn = true;
      try {
        await criarTag(event).then(() => {
          this.success = true;
        });
        this.loadingBtn = false;
      } catch (e) {
        this.loadingBtn = false;
        this.error = true;
        this.messageError = e.response.data.message;
      }
    },
    goToTags() {
      this.sucess = false;
      this.$router.push({ name: "Tags" });
    },
  },
};
</script>

<style></style>
